import { useQuery } from "@apollo/client";
import { Combobox } from "@/components/Combobox";
import { graphql, type ResultOf } from "@/graphql";
import { removeNothings } from "@/lib/utils/arrays";
import { getSubdivisionOptionsForCodes } from "@/lib/utils/countries";

type Props = {
  id?: string;
  selected: Array<string>;
  onSelect: (values: Array<string>) => void;
  className?: string;
};

export type DestinationStateData = ResultOf<typeof destinationStateCodesQuery>;

export function DestinationStatePicker({ id, selected, onSelect, className }: Props) {
  const { data, loading } = useQuery(destinationStateCodesQuery);

  const options = getSubdivisionOptionsForCodes(removeNothings(data?.supplyChainLotDestinationStateCodes || []));

  return (
    <Combobox<string>
      id={id}
      name="destination-states"
      options={options}
      selected={selected}
      onChange={onSelect}
      loading={loading}
      type="multi"
      className={className}
    />
  );
}

export const destinationStateCodesQuery = graphql(`
  query SupplyChainLotDestinationStateCodes {
    supplyChainLotDestinationStateCodes
  }
`);
